//@flow
import { connect } from 'react-redux';
import TaxFootnote from './TaxFootnote';
import { isExemptedFromTaxSelector, isMalaysianSelector } from '../../modules/Customer/selectors';

const mapStateToProps = state => ({
  isExemptedFromTax: isExemptedFromTaxSelector(state),
  isNotMalaysian: !isMalaysianSelector(state),
});

export default connect(mapStateToProps)(TaxFootnote);
